import React from "react";
import Subscription from "../../components/Subscription/Subscription_card";

export default function SubscriptionContainer() {
  return (
    <React.Fragment>
      <Subscription />
    </React.Fragment>
  );
}